module.exports = __webpack_public_path__ + "static/media/APP_RisingStar_152x174_6.f89a9fa3.png";